var React = require('react');

function DefaultInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"default_file"),React.createElement("path",{"d":"M20.414,2H5V30H27V8.586ZM7,28V4H19v6h6V28Z","style":{"fill":"#c5c5c5"},"key":1})]);
}

DefaultInline.defaultProps = {"viewBox":"0 0 32 32","role":"img","focusable":"false"};

module.exports = DefaultInline;

DefaultInline.default = DefaultInline;
